// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-tag-list[data-v-5d135483] {\n  padding: 0;\n}\n@media screen and (max-width: 1023px) {\n.b-tag-list[data-v-5d135483] {\n    padding: 0.5rem 0.75rem;\n}\n}\n@media screen and (max-width: 768px) {\n.b-tag[data-v-5d135483] {\n    flex-grow: 1;\n}\n}", ""]);
// Exports
module.exports = exports;
